import { getData } from '../utils/data.js';
export const ClientInvitationEmailStatus = {
    Accepted: 'accepted',
    Failed: 'failed',
};
export const clientInvitationConverter = {
    fromFirestore(snap, op) {
        return getData(snap, op);
    },
    toFirestore(c) {
        return c;
    },
};
export const createInvitationInput = (email, client, from, role) => {
    const now = new Date();
    const expiresAt = new Date();
    expiresAt.setDate(now.getDate() + 7);
    return {
        email,
        role,
        group: {
            id: client.id,
            name: client.name,
        },
        from: {
            id: from.id,
            email: from.email,
            name: from.displayName,
        },
        emailStatus: null,
        expiresAt: expiresAt,
        acceptedAt: null,
        deniedAt: null,
        createdAt: now,
        updatedAt: now,
    };
};
//# sourceMappingURL=clientInvitation.js.map